import { api } from '~/plugins/api'
import { FavoritoRepository } from './favorito-repository'
import { ref, watch } from 'vue'
import { Favorito } from './favorito'
import { codigo_cliente } from '../auth'

export * from './favorito'
export * from './favorito-repository'

export const favoritos = ref<Favorito[]>([])

export const favorito_repository = new FavoritoRepository(api)

export const loadFavoritos = async () => {
    try {
        favoritos.value = await favorito_repository.listar()
    } catch (err) {
        favoritos.value = []
        console.error(err)
    }
}


watch(codigo_cliente, () => {
    favoritos.value = []
    loadFavoritos()
})

//loadFavoritos()